export default "c37ad9198d17c5d0.png"